import { Group, GroupUUID, Menu, RecipeUUID } from '@library/menu-service'
import { GroupSlug } from '@library/menu-service/internal/types'

import { actionTypes } from 'actions/actionTypes'

export type { Group }

type MenuV3GroupsSlice = {
  groups: Record<GroupUUID, Group>
}
export type MenuGroupsState = {
  menuV3Groups: MenuV3GroupsSlice
}

type Action = {
  type: typeof actionTypes.MENU_SERVICE_V3_DATA_RECEIVED
  response: Menu
}

const initialState: MenuV3GroupsSlice = {
  groups: {},
}

export const menuGroupsReducers = {
  menuV3Groups: (state = initialState, action: Action): MenuV3GroupsSlice => {
    switch (action.type) {
      case actionTypes.MENU_SERVICE_V3_DATA_RECEIVED: {
        return {
          groups: Object.fromEntries(
            Object.values(action.response.groups || {})
              .sort((a, b) => a.order - b.order)
              .map((group) => ({
                displayType: group.display_type,
                description: group.description,
                id: group.id as GroupUUID,
                order: group.order,
                recipeCount: group.recipe_count,
                recipes: group.recipes.map((recipe) => ({
                  id: recipe.id as RecipeUUID,
                  options: recipe.options.map((option) => ({
                    id: option.id as RecipeUUID,
                  })),
                })),
                slug: group.slug as GroupSlug,
                title: group.title,
              }))
              .map((group) => [group.id, group]),
          ),
        }
      }
      default: {
        return state
      }
    }
  },
}
